import React from "react"

import { Link } from 'gatsby'

import NavigationItems from '../data/navigation.yaml'

export default function FooterLinksRow () {
  return (
    <div className="row d-flex justify-content-between">
      <div className="col-auto">
        <div className="row mx-n4">
          {
            NavigationItems.map((item, idx) => {
              return (
                <div className="col-auto mb-3 px-4" key={`content_item_${idx}`}>
                  <Link className="text-uppercase text-heading ls-01" to={ item.href }>{ item.title }</Link>
                </div>
              )
            })
          }
        </div>
      </div>
      <div className="col-auto">
        <p className="mb-0 text-uppercase font-weight-light">
          Copyright {new Date().getFullYear()} stokes construction | All rights reserved.
        </p>
      </div>
    </div>
  )
}